import { getParameterFromURL } from '../scripts';
import readCookie from '../scripts/readCookie';

function getParameterFromCookie(parameter: string): string | null {
	return (typeof document !== 'undefined') ? readCookie(parameter) : null;
}

function getLanguage(): string {
	return (typeof window !== 'undefined') ? window.navigator.language : '';
}

const OneLinkParametersHelper = {
	getParameterFromCookie: (parameter: string) => getParameterFromCookie(parameter),
	getLanguage: () => getLanguage(),

	getFBclickId: (sourceURL: string) => {
		const fbclidValue = getParameterFromURL('fbclid', sourceURL);
		let fbcFinal: string | null = null;
		if (fbclidValue) fbcFinal = `fb.1.${Date.now()}.${fbclidValue}`;

		return getParameterFromURL('fbc', sourceURL) ||
      getParameterFromCookie('_fbc') ||
      fbcFinal ||
      '';
	},

	getFBp: (sourceURL: string) => {
		return getParameterFromURL('fbp', sourceURL) ||
      getParameterFromCookie('_fbp') ||
      '';
	},

	validatePromocode: (promocode: string | null | undefined) => {
		return promocode && promocode !== '';
	},

	prepareOneLinkParameters: (sourceURL: string) => {
		const pid = getParameterFromURL('pid', sourceURL);
		const af_pid = getParameterFromURL('af_pid', sourceURL);
		const utm_source = getParameterFromURL('utm_source', sourceURL);

		let pidValue: string | null = null;
		if (pid) {
			pidValue = pid;
		} else if (af_pid) {
			pidValue = af_pid;
		} else if (utm_source) {
			pidValue = utm_source;
		} else if (typeof document !== 'undefined') {
			pidValue = document.referrer;
		}

		const c = getParameterFromURL('c', sourceURL);
		const af_c = getParameterFromURL('af_c', sourceURL);
		const utm_campaign = getParameterFromURL('utm_campaign', sourceURL);

		let campaignValue: string | null = null;
		if (c) {
			campaignValue = c;
		} else if (af_c) {
			campaignValue = af_c;
		} else if (utm_campaign) {
			campaignValue = utm_campaign;
		} else if (getParameterFromURL('withStripe', sourceURL) === 'true') {
			campaignValue = 'paid-web-onboarding';
		} else {
			campaignValue = 'free-web-onboarding';
		}

		const af_prt = getParameterFromURL('af_prt', sourceURL);
		const af_adset = getParameterFromURL('utm_term', sourceURL);
		const af_ad = getParameterFromURL('utm_content', sourceURL);
		const utm_id = getParameterFromURL('utm_id', sourceURL);

		const onelink_params = {
			...(pidValue && { pid: pidValue }),
			...(campaignValue && { c: campaignValue }),
			...(af_prt && { af_prt }),
			...(af_adset && { af_adset }),
			...(af_ad && { af_ad }),
			...(utm_id && { utm_id }),
			deep_link_value: 'paid-web-onboarding',
		};
		return onelink_params;
	}
};

export default OneLinkParametersHelper;